import { ChevronRightIcon, } from "@heroicons/react/24/outline"; // Heroicons v2
import createIcon from "./createIcon";

const KeyboardArrowRight = createIcon(ChevronRightIcon, "KeyboardArrowRight");

export default KeyboardArrowRight;
